import { Component, OnInit, Input } from '@angular/core';
import { TranslationObject } from 'src/app/helper/TranslationObject';

@Component({
  selector: 'app-applicants-downloader',
  templateUrl: './applicants-downloader.component.html',
  styleUrls: ['./applicants-downloader.component.scss'],
})
export class ApplicantsDownloaderComponent implements OnInit {
  @Input() applicantNumber;
  @Input() form;
  @Input() isLeffer;
  @Input() conversationMessages;
  @Input() languageTest;
  @Input() talent360Information;
  @Input() bewerberForm;
  @Input() recruitmentTests;
  @Input() totalReachedPoints;
  @Input() totalPoints;
  @Input() getTestIds: () => any;
  @Input() getScorePerTest: (testId: any) => any;
  
  @Input() languageClass: string = "";

  recruitmentTestsMap:any; // STILL NEED TO BE IMPLEMENTED, #TODO #FIXME
  translationObject: any;

  constructor() {
    this.translationObject = TranslationObject.TRANSLATION_OBJECT;
  }

  ngOnInit() {
  }

  getTestsIds() {
    return this.getTestIds();
  }
  getScorePerTests(testId) {
    return this.getScorePerTest(testId);

  }
}
